/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_ACTION = '/deliveryCalendar';
const RESOURCE_ROOT_FACADE_AVAIL = '/availability';

const getDeliveryCalendarByProduct = (
    wcEnv,
    jwtToken,
    skuProductCode,
    brandCode,
    zipCode,
    locationType,
    startDate,
    customerType,
    subscriptionType = null,
    flexVersion,
) => {
    // eslint-disable-next-line no-param-reassign
    wcEnv.rootUri = RESOURCE_ROOT_FACADE_AVAIL;

    let resourcePage = `${RESOURCE_PAGE_ACTION}?`;

    resourcePage += `skuProductCode=${skuProductCode}`;
    resourcePage += `&brandCode=${brandCode}`;
    resourcePage += `&zipCode=${zipCode}`;
    resourcePage += `&locationType=${locationType}`;
    resourcePage += `&startDate=${startDate}`;
    resourcePage += `&customerType=${customerType}`;

    if (subscriptionType) {
        resourcePage += `&subscriptionType=${subscriptionType}`;
    }

    // if flex version 2.0, ask for that variant
    if (flexVersion) {
        resourcePage += '&variant=flex2';
    }

    return restClient.getFacade(wcEnv, resourcePage, jwtToken, null)
        .then((response) => response);
};

export default getDeliveryCalendarByProduct;
